<template>
  <section :class="$style.pressContainer">
    <Wrapper :class="$style.inner">
      <PressSidebar :class="$style.sidebar" :content="content" />
      <div :class="$style.listContainer">
        <PressList
          v-for="(list, listId) in items"
          :key="listId"
          :class="$style.pressList"
          :list-content="list"
          @title-active="addTitleToProgression($event)"
          @title-inactive="removeTitleFromProgression($event)"
        />
      </div>
    </Wrapper>
  </section>
</template>

<script>
import PressSidebar from '../PressSidebar'
import PressList from '../PressList'

export default {
  name: 'PressContent',

  components: {
    PressSidebar,
    PressList,
  },

  props: {
    slice: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      titleProgression: [],
    }
  },

  computed: {
    content() {
      return { ...this.slice.primary, titlesProgression: this.titleProgression }
    },

    items() {
      return this.slice.items
    },
  },

  methods: {
    addTitleToProgression(title) {
      if (!this.titleProgression.includes(title)) {
        this.titleProgression.push(title)
      }
    },

    removeTitleFromProgression(title) {
      const index = this.titleProgression.indexOf(title)
      if (index > -1) {
        this.titleProgression.splice(index, 1)
      }
    },
  },
}
</script>

<style lang="scss" module>
.pressContainer {
  padding: 0 24px 128px;
}

.inner {
  display: grid;
  grid-template-columns: repeat(4, 1fr);

  column-gap: 40px;
}

.sidebar {
  display: none;

  @include above(medium) {
    display: block;
    grid-column: 1;
    padding-top: 128px;
  }
}

.listContainer {
  grid-column: 1 / 5;
  @include above(medium) {
    grid-column: 2 / 5;
  }
}

.pressList {
  padding-top: 128px;

  &:first-child {
    margin-top: 0;
  }
}
</style>
